import React from 'react';

export const FlagUser: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'>
    <path
      fill='red'
      fillRule='evenodd'
      d='M6 3a1 1 0 10-2 0v10a1 1 0 102 0V9h7l-2-3 2-3H6z'
      clipRule='evenodd'
    ></path>
  </svg>
);
